/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */
import helper from "../utils/Helper";

export const getVariantID = variant =>
  variant && variant.id ? variant.id : null;
export const getVariantName = variant =>
  variant && variant.name ? variant.name : null;
export const getVariantShortName = variant =>
  variant && variant.short_name ? variant.short_name : null;
export const getVariantDescription = variant =>
  variant && variant.description ? variant.description : null;
export const getVariantItems = variant =>
  variant && variant.items ? variant.items : [];

export const getVariantImageStatus = variant =>
  variant && variant.attribute && variant.attribute.is_show_image
    ? variant.attribute.is_show_image
    : false;

// variant -> item || addOn -> item
export const getVariantItemID = item => (item && item.id ? item.id : null);
export const getVariantItemTitle = item =>
  item && item.title ? item.title : null;
export const getVariantItemImage = item =>
  item && item.image && item.image.large && item.image.large.src
    ? item.image.large.src
    : null;
export const getVariantItemName = item =>
  item && item.name ? item.name : null;
export const getVariantItemDescription = item =>
  item && item.description ? item.description : null;
export const getVariantItemUnitPrice = item =>
  item && item.unit_price ? item.unit_price : 0;
export const getVariantItemPriceText = item =>
  item && item.price_text ? item.price_text : null;
export const getVariantItemIsSelected = item =>
  item && item.is_selected ? item.is_selected : false;
export const variantItemCurrencySymbol = item =>
  item && item.currency && item.currency.symbol ? item.currency.symbol : null;
export const getVariantItemLocalizedSellingPriceInString = item =>
  item && item.unit_price
    ? helper.formatPriceNumber(item.unit_price.toString())
    : "0.00";
export const getVariantItemLocalizedSellingPriceWithCurrency = item =>
  item
    ? `${variantItemCurrencySymbol(
        item
      )} ${getVariantItemLocalizedSellingPriceInString(item)}`
    : "";



// WEBPACK FOOTER //
// ./src/selectors/variant.js